import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import './WhatsAppButton.css';
import wp from '../../Gemco-Website-Images/favicon.ico';

const WhatsAppButton = () => {
   const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="whatsapp-container">
      
      {/* Popup */}
      {showPopup && (
        <div className="whatsapp-popup">
          <p>Contact Us</p>
          <a
            href="https://wa.me/919999999999"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat on WhatsApp
          </a>

          <button
            className="close-btn"
            onClick={() => setShowPopup(false)}
          >
            <FaTimes />
          </button>
        </div>
      )}

      {/* Floating Button */}
      <button
        className="whatsapp-button"
        onClick={() => setShowPopup(!showPopup)}
      >
        <div className="whatsapp-icon">
         <img src={wp} style={{ width: "80px" }} alt="gemco logo" />
       </div>
      </button>
    </div>
    // <div>
    //    <a
    //   href="https://wa.me/971501234567"
    //   target="_blank"
    //   rel="noopener noreferrer"
    //   className="wa-wrapper"
    // >

    //   <div className="whatsapp-icon">
    //     <img src={wp} style={{ width: "80px" }} alt="gemco logo" />
    //   </div>
    // </a>
    // </div>
  )
}

export default WhatsAppButton